import React, { useState, useEffect, useRef, useCallback } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || '';
const token = () => localStorage.getItem('token');
const headers = () => ({ Authorization: `Bearer ${token()}` });

function getEmpresaId() {
  try {
    const u = JSON.parse(atob(token().split('.')[1]));
    return u.empresaId || u.id;
  } catch { return null; }
}

function tiempoRel(iso) {
  try {
    const diff = Date.now() - new Date(iso).getTime();
    const min = Math.floor(diff / 60000);
    if (min < 1) return 'ahora';
    if (min < 60) return `hace ${min} min`;
    const h = Math.floor(min / 60);
    if (h < 24) return `hace ${h} h`;
    const d = Math.floor(h / 24);
    return `hace ${d} d`;
  } catch { return ''; }
}

const ICONO = { lead_nuevo: '🎯', intervencion_humana: '🙋', general: '🔔' };

export default function NotificacionesBell() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [noLeidas, setNoLeidas] = useState(0);
  const panelRef = useRef(null);
  const btnRef = useRef(null);
  const socketRef = useRef(null);
  const navigate = useNavigate();

  const cargar = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/notificaciones?limite=30`, { headers: headers() });
      setItems(res.data.data || []);
      setNoLeidas(res.data.no_leidas || 0);
    } catch { /* silencioso */ }
  }, []);

  useEffect(() => {
    if (!token()) return;
    cargar();

    const eid = getEmpresaId();
    if (!eid) return;
    const base = API || window.location.origin;
    const socket = io(`${base}/chat`, {
      path: '/socket.io',
      transports: ['polling', 'websocket'],
      reconnection: true,
      reconnectionDelay: 2000,
    });
    socket.on('connect', () => socket.emit('join_empresa', { empresa_id: eid }));
    socket.on('notificacion', (notif) => {
      setItems(prev => [notif, ...prev].slice(0, 30));
      setNoLeidas(n => n + 1);
    });
    socketRef.current = socket;

    // Respaldo: refrescar contador cada 60s por si se pierde el socket
    const iv = setInterval(cargar, 60000);
    return () => { socket.disconnect(); clearInterval(iv); };
  }, [cargar]);

  // Cerrar al hacer click fuera
  useEffect(() => {
    function onClick(e) {
      if (open && panelRef.current && !panelRef.current.contains(e.target) && !btnRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  async function abrir() {
    const nuevoEstado = !open;
    setOpen(nuevoEstado);
    if (nuevoEstado && noLeidas > 0) {
      // Marcar todas como leídas al abrir
      try {
        await axios.post(`${API}/api/notificaciones/leer-todas`, {}, { headers: headers() });
        setNoLeidas(0);
        setItems(prev => prev.map(n => ({ ...n, leida: true })));
      } catch { /* silencioso */ }
    }
  }

  function irA(notif) {
    setOpen(false);
    if (notif.conversacion_id) navigate('/crm/bandeja');
    else if (notif.tipo === 'lead_nuevo') navigate('/crm/contactos');
  }

  return (
    <div style={{ position: 'relative' }}>
      <button
        ref={btnRef}
        onClick={abrir}
        aria-label="Notificaciones"
        style={{
          background: 'none', border: 'none', cursor: 'pointer', position: 'relative',
          fontSize: 22, lineHeight: 1, padding: 6, borderRadius: 8, color: '#fff',
        }}
      >
        🔔
        {noLeidas > 0 && (
          <span style={{
            position: 'absolute', top: 0, right: 0, background: '#f44336', color: '#fff',
            borderRadius: '50%', minWidth: 18, height: 18, fontSize: 11, fontWeight: 700,
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px',
            boxShadow: '0 0 0 2px #111827',
          }}>
            {noLeidas > 99 ? '99+' : noLeidas}
          </span>
        )}
      </button>

      {open && (
        <div
          ref={panelRef}
          style={{
            position: 'absolute', top: 42, right: 0, width: 340, maxWidth: '90vw',
            maxHeight: 440, background: '#fff', borderRadius: 12,
            boxShadow: '0 12px 40px rgba(0,0,0,.22)', zIndex: 1300, overflow: 'hidden',
            display: 'flex', flexDirection: 'column', color: '#1f2937',
          }}
        >
          <div style={{
            padding: '14px 16px', borderBottom: '1px solid #eef0f3',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}>
            <strong style={{ fontSize: 15 }}>Notificaciones</strong>
          </div>

          <div style={{ overflowY: 'auto', flex: 1 }}>
            {items.length === 0 ? (
              <div style={{ padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
                No tienes notificaciones
              </div>
            ) : items.map(n => (
              <div
                key={n.id}
                onClick={() => irA(n)}
                style={{
                  padding: '12px 16px', borderBottom: '1px solid #f3f4f6', cursor: 'pointer',
                  background: n.leida ? '#fff' : '#eff6ff', display: 'flex', gap: 10,
                }}
              >
                <div style={{ fontSize: 20, flexShrink: 0 }}>{ICONO[n.tipo] || ICONO.general}</div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 2 }}>{n.titulo}</div>
                  <div style={{ fontSize: 12.5, color: '#4b5563', lineHeight: 1.4 }}>{n.mensaje}</div>
                  <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 3 }}>{tiempoRel(n.created_at)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
